// extracted by mini-css-extract-plugin
module.exports = {"THEME_NAME":"\"fixtercore\"","component":"LinksList_component__RmWUD"};